import * as React from "react";

export const Pause = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="svg-icon pause-icon"
    viewBox="0 0 85 85"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M42.5 2.5a40 40 0 1 1-40 40 40 40 0 0 1 40-40"
      className="control-path circle-opaque"
    ></path>
    <path
      d="M50 28.25a2 2 0 0 1 2 2v24a2 2 0 1 1-4 0v-24a2 2 0 0 1 2-2M35 28.25a2 2 0 0 1 2 2v24a2 2 0 1 1-4 0v-24a2 2 0 0 1 2-2"
      fill="currentColor"
      className="control-fill pause-line"
    ></path>
  </svg>
);
